<div id="globalGlobalContainer">
    <div id="GreekParallax"> </div>
  
<div id="globalContainer">
    <div id="header">
        <nav>
            <a routerLink="/dashboard">Dashboard</a>
            <a routerLink="/articles">Myth Classed</a>
            <a routerLink="/familyTree">Family Tree</a>
            <a routerLink="/galery">Gallery</a>
        </nav>
    </div>
    <div id="animation">
    <div id="container">
        <img id="familyTree" src="../../assets/images/familyTree.jpg" alt="FamilyTreeImage"/>
    
    </div>
    
    
    
    </div>
    </div>
    <div id="GreekParallax"></div>
</div>